module.exports = __webpack_public_path__ + "static/media/quiz-casa.aea40ebe.png";